<template>
  <div class="debug">
    <ProjectObjectItem :object="object" :level="0" />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import ProjectObjectItem from './ProjectObjectItem';

export default {
  name: 'ProjectObject',
  props: [],
  data() {
    return {
      object: { object: 'loading' },
    };
  },
  mounted: function () {
    this.getProjectItem(this.$route.params._id).then((obj) => {
      this.object = obj;
    });
  },
  methods: {
    ...mapActions(['getProjectItem']),
  },
  components: {
    ProjectObjectItem,
  },
  watch: {
    $route: function (to, from) {
      this.getProjectItem(this.$route.params._id).then((obj) => {
        this.object = obj;
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/projectoverview/ProjectObject.vue